import './App.css';
import { Navbar } from './component/Navbar';
import { AllRoutes } from './router/AllRoutes';

function App() {
  return (
    <>
   <Navbar/>
   <AllRoutes/>
    </>
  );
}

export default App;
